module.exports = __webpack_public_path__ + "static/media/EthanLee.824033df.png";